import {
  items_coupon_discount_Failure,
  items_coupon_discount_Request,
  items_coupon_discount_Success,
  userCreateOrderFailure,
  userCreateOrderRequest,
  userCreateOrderSuccess,
  user_all_order,
  user_order_detail,
} from "../../reducers/users/order";
import service from "../index";

export const userCreateOrder = (apiData) => async (dispatch) => {
  dispatch(userCreateOrderRequest());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Order/CreateOrder", apiData);
      resolve(res?.data);
      dispatch(userCreateOrderSuccess(res?.data));
    } catch (err) {
      dispatch(userCreateOrderFailure());
      reject(err?.data);
    }
  });
};

export const user_all_orders = (apiData) => async (dispatch) => {
  // dispatch(userCreateOrderRequest());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Order/GetAllOrders", apiData);
      resolve(res?.data);
      dispatch(user_all_order(res?.data));
    } catch (err) {
      reject(err?.data);
      // dispatch(userCreateOrderFailure());
    }
  });
};

export const user_order_details = (apiData) => async (dispatch) => {
  // dispatch(userCreateOrderRequest());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Order/GetOrderById", apiData);
      resolve(res?.data);
      dispatch(user_order_detail(res?.data));
    } catch (err) {
      reject(err?.data);
      // dispatch(userCreateOrderFailure());
    }
  });
};

export const user_order_cancel = (apiData) => async (dispatch) => {
  // dispatch(userCreateOrderRequest());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Order/CancelOrder", apiData);
      resolve(res?.data);
      // dispatch(user_order_detail(res?.data));
    } catch (err) {
      reject(err?.data);
      // dispatch(userCreateOrderFailure());
    }
  });
};
export const updateOrderStatus = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Order/UpdateOrderStatus", apiData);
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};

export const order_tracking_number = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("Order/UpdateTrackingNumber", apiData);
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};

export const items_coupon_discount = (apiData) => async (dispatch) => {
  dispatch(items_coupon_discount_Request());
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post("SystemDiscounts/DiscountEligibility", apiData);
      resolve(res?.data);
      dispatch(items_coupon_discount_Success(res?.data));
    } catch (err) {
      reject(err?.data);
      dispatch(items_coupon_discount_Failure());
    }
  });
};
